module.exports = __webpack_public_path__ + "static/media/snp.cb1e629f.png";